export function relationStudentClassListToRelateByClassQuery(termId, classId) {
  const query = `{relationStudentClassListToRelateByClass(termId: ${termId}, classId: ${classId}) {id, initialDateInMilli, finalDateInMilli, active, student{id, fullName}, schoolShift{id, name, classQuantity}}}`;
  return query;
}

export function relationStudentClassListRelatedByClass(classId) {
  const query = `{relationStudentClassListRelatedByClass(classId: ${classId}) {id, initialDateInMilli, finalDateInMilli, active, student{id, fullName}, schoolShift{id, name, classQuantity}}}`;
  return query;
}

export function relationStudentClassListByStudent(studentID) {
  const query = `{relationStudentClassListByStudent(studentId: ${studentID}){id, initialDateInMilli, finalDateInMilli, active, schoolClass{id, name, year}, schoolShift{id, name}}}`;
  return query;
}

export function relationStudentClassListToEnroll(studentID) {
  const query = `{relationStudentClassListToEnroll(studentId: ${studentID}){id,  schoolClass{id, name, year}, schoolShift{id, name}}}`;
  return query;
}

export function relationStudentClassRemoveById(relationId) {
  const query = `mutation { 
     relationStudentClassRemoveById(id: ${relationId})
  }`;
  return query;
}

export function relationStudentActiveClassListToEnroll(studentID) {
  return `{relationStudentActiveClassListToEnroll(studentId: ${studentID}){id,  schoolClass{id, name, year}, schoolShift{id, name}, period{initialDate, finalDate}}}`;
}
